import React, { Component } from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import Svg from "../_svgs/svg"
import { handleEvalTracking } from "../../helpers/tracking"

export class ItineraryBaggage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
      accordionOpen: false,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)

    this.showSignupModal = this.props.showSignupModal.bind(this)
  }

  formatTime(time) {
    if (time) {
      var date = new Date(time)
      return date
        .toLocaleTimeString("da", {
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(".", ":")
    }
    return ""
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.setState({ accordionOpen: !this.state.accordionOpen })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.state.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.state.block.backgroundColor)
    const hasContentBlocks = this.state.block.contentArea?.length > 0
    const hasFocusContentBlocks = this.state.block.focusContentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    const oddSizeIcon = SelectionFactoryHelper.getFromSelectionFactory(this.state.block.oddSizeIcon)

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    const signUpLinkCarousel = (
      <React.Fragment>
        <button className={"pointer sign-up-link"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.showSignupModal() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.baggageSignUpText || "(Tilmeld info)" : ""}
        </button>{" "}
        {this.props.currentPageJson.baggageCarouselFallbackValue || "Afventer"}
      </React.Fragment>
    )
    const signUpLinkEstimatedTime = (
      <React.Fragment>
        <button className={"pointer sign-up-link"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.showSignupModal() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.baggageSignUpText || "(Tilmeld info)" : ""}
        </button>{" "}
        {this.props.currentPageJson.estimatedBaggageDeliveryTimeFallbackValue || "Afventer"}
      </React.Fragment>
    )
    const signUpLinkStatus = (
      <React.Fragment>
        <button className={"pointer sign-up-link"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.showSignupModal() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.baggageSignUpText || "(Tilmeld info)" : ""}
        </button>{" "}
        {this.props.currentPageJson.statusFallbackValue || "Afventer"}
      </React.Fragment>
    )

    const firstBagTime = this.state.flightInfo.FirstBagTime && new Date(this.state.flightInfo.FirstBagTime)
    const lastBagTime = this.state.flightInfo.LastBag && new Date(this.state.flightInfo.LastBag)
    const currentTime = new Date()
    let bagStatus = ""
    if (currentTime > lastBagTime) {
      bagStatus = this.state.block.afterLastBagLabel ?? "Bagage Leveret"
    } else if ((!lastBagTime && currentTime > firstBagTime) || (currentTime < lastBagTime && currentTime > firstBagTime)) {
      bagStatus = this.state.block.duringBagLabel ?? "Bagage Ruller"
    } else {
      bagStatus = this.state.block.beforeFirstBagLabel ?? "Afventer"
    }

    const firstBagTimeFormatted = this.state.flightInfo.FirstBagTime ? this.formatTime(this.state.flightInfo.FirstBagTime) : undefined

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem foldable ${theme ? theme : ""}`}
      >
        <button
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          aria-expanded={this.state.accordionOpen}
          aria-label={
            this.state.accordionOpen
              ? `${this.props.currentPageJson?.closeContentLabel || "Luk indhold for sektionen"} ${this.props.block.heading}`
              : `${this.props.currentPageJson?.openContentLabel || "Åben indhold for sektionen"} ${this.props.block.heading}`
          }
          onClick={(e) => this.handleAccordionClick(e)}
        >
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading.replace("{time}", firstBagTimeFormatted ?? "")}</h6> : ""}
          {this.props.block.showBaggageInformation ? (
            <div className="floatbox">
              {this.state.flightInfo.BaggageCarousel && this.state.flightInfo.BaggageCarousel !== ""
                ? (this.props.block.baggageCarouselLabelFloatbox || "Bånd ") + this.state.flightInfo.BaggageCarousel
                : this.props.currentPageJson.baggageCarouselFallbackValue || "Afventer"}
            </div>
          ) : (
            ""
          )}
        </button>
        <div className={"contentWrapper show-hide hide-content"}>
          {this.props.block.showBaggageInformation ? (
            <div className="departure-info__essentials__detailitems__detailitem__infobox">
              <div className="grid">
                <div className="grid-item col--12">
                  <div className="info-text">{this.props.block.baggageCarouselLabel || "Bagagebånd"}</div>
                  <h5 className={this.state.flightInfo.BaggageCarousel ? "" : "awaiting"}>
                    {this.state.flightInfo.BaggageCarousel ? this.state.flightInfo.BaggageCarousel : signUpLinkCarousel}
                  </h5>
                </div>
                <div className="grid-item col--12">
                  <div className="info-text">{this.props.block.estimatedBaggageDeliveryTimeLabel || "Forventet levering"}</div>
                  <h5 className={firstBagTimeFormatted ? "" : "awaiting"}>{firstBagTimeFormatted ?? signUpLinkEstimatedTime}</h5>
                </div>
                <div className="grid-item col--12">
                  <div className="info-text">{this.props.block.baggageStatusLabel || "Status"}</div>
                  <h5 className={this.state.flightInfo.PublicRemark ? "" : "awaiting"}>
                    {this.state.flightInfo.PublicRemark ? bagStatus : signUpLinkStatus}
                  </h5>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {this.props.block.baggageText ? (
            <div className={"textbuttoncontainer"}>
              <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.baggageText }}></span>
            </div>
          ) : (
            ""
          )}

          {(this.props.block.oddSizeIconUpload || oddSizeIcon) && this.props.block.oddSizeHeading && this.props.block.oddSizeText ? (
            <div className="texticoncontainer">
              {this.props.block.oddSizeIconUpload ? (
                <img className="icon" src={this.props.block.oddSizeIconUpload} alt={this.props.block.oddSizeIconAltText} />
              ) : oddSizeIcon ? (
                <Svg iconName={oddSizeIcon} label={this.props.block.oddSizeIconAltText} />
              ) : (
                ""
              )}
              <div className="texticon-header">{this.props.block.oddSizeHeading || "Odd-size bagage"}</div>
              <div className="texticon-info">{this.props.block.oddSizeText || "Odd-size bagage udleveres særskilt ved Bånd 9"}</div>
            </div>
          ) : (
            ""
          )}

          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}

          {hasFocusContentBlocks ? <div>{this.renderContentBlocks(this.state.block.focusContentArea, true, this.state.accordionOpen)}</div> : ""}
          {hasContentBlocks ? this.renderContentBlocks(this.state.block.contentArea, true, this.state.accordionOpen) : ""}
        </div>
      </div>
    )
  }
}
